import React from 'react'
import clsx from 'clsx'

/**
 * SignupStepIndicator Component
 *
 * Displays progress through the multi-step signup process
 */
const SignupStepIndicator = ({ currentStep, totalSteps = 3 }) => {
  const steps = []

  return <div className="mb-4" />
}

export default SignupStepIndicator
